export function strToBool(s) {
  if (typeof s !== 'string') return !!s;
  // will match one and only one of the string 'true', rerardless
  // of capitalization and regardless off surrounding white-space.
  //
  const regex = /^\s*(true)\s*$/i;

  return regex.test(s);
}

export const strWithDefaultValue = (s, defaultValue = '--') => {
  return s || defaultValue;
};

export const getUidFromHref = (href) => {
  return href ? href.split('id/').pop() : null;
};

export const capitalizeEveryFirstLetter = (str) => {
  return str.toLowerCase().replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());
};

export const hasNonLatinCharRegExp = (str) => {
  return str.replace(/[^\w` \n~!@#$%^&*()\-+={}[\];;':",.<>?/\\|]/gm, '');
};

export const boolToStr = (isTrue) => {
  return isTrue ? 'Yes' : 'No';
};